"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/*
  The MIT License

  Copyright (c) 2017-2019 EclipseSource Munich
  https://github.com/eclipsesource/jsonforms

  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:

  The above copyright notice and this permission notice shall be included in
  all copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
  THE SOFTWARE.
*/
var react_1 = tslib_1.__importDefault(require("react"));
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var core_1 = require("@jsonforms/core");
var react_2 = require("@jsonforms/react");
var reducers_1 = require("../reducers");
var styling_1 = require("../reducers/styling");
var styles_1 = require("../styles");
/**
 * Add vanilla props to the return value of calling the given
 * mapStateToProps function.
 *
 * @param mapStateToProps existing mapStateToProps function
 * @returns {VanillaControlStateProps} vanilla-specific control props
 */
exports.addVanillaControlProps = function (mapStateToProps) { return function (state, ownProps) {
    var props = mapStateToProps(state, ownProps);
    var config = core_1.getConfig(state);
    var trim = config.trim;
    var controlElement = props.uischema;
    var isValid = isEmpty_1.default(props.errors);
    var styles = reducers_1.getStyle(state)('control');
    var classNames = !isEmpty_1.default(controlElement.scope)
        ? styles.concat(["" + core_1.convertToValidClassName(controlElement.scope)])
        : [''];
    if (trim) {
        classNames = classNames.concat(reducers_1.getStyle(state)('control.trim'));
    }
    var labelClass = reducers_1.getStyleAsClassName(state)('control.label');
    var descriptionClassName = reducers_1.getStyleAsClassName(state)('input.description');
    var validationClassName = reducers_1.getStyleAsClassName(state)('control.validation');
    var validationErrorClassName = reducers_1.getStyleAsClassName(state)('control.validation.error');
    var inputClassName = ['validate'].concat(isValid ? 'valid' : 'invalid');
    return tslib_1.__assign(tslib_1.__assign({}, props), { getStyleAsClassName: reducers_1.getStyleAsClassName(state), getStyle: reducers_1.getStyle(state), classNames: {
            wrapper: classNames.join(' '),
            input: inputClassName.join(' '),
            label: labelClass,
            description: descriptionClassName,
            validation: validationClassName,
            validationError: validationErrorClassName
        } });
}; };
exports.withVanillaControlProps = function (Component) { return function (props) {
    var ctx = react_2.useJsonForms();
    var contextStyles = styles_1.useStyles();
    var controlElement = props.uischema;
    var config = ctx.config;
    var trim = config && config.trim;
    var styles = styling_1.findStyle(contextStyles)('control');
    var classNames = !isEmpty_1.default(controlElement.scope)
        ? styles.concat(["" + core_1.convertToValidClassName(controlElement.scope)])
        : [''];
    if (trim) {
        classNames = classNames.concat(styling_1.findStyle(contextStyles)('control.trim'));
    }
    var isValid = isEmpty_1.default(props.errors);
    var labelClass = styling_1.findStyleAsClassName(contextStyles)('control.label');
    var descriptionClassName = styling_1.findStyleAsClassName(contextStyles)('input.description');
    var validationClassName = styling_1.findStyleAsClassName(contextStyles)('control.validation');
    var validationErrorClassName = styling_1.findStyleAsClassName(contextStyles)('control.validation.error');
    var inputClassName = ['validate'].concat(isValid ? 'valid' : 'invalid');
    return (react_1.default.createElement(Component, tslib_1.__assign({}, props, { getStyleAsClassName: styling_1.findStyleAsClassName(contextStyles), getStyle: styling_1.findStyle(contextStyles), classNames: {
            wrapper: classNames.join(' '),
            input: inputClassName.join(' '),
            label: labelClass,
            description: descriptionClassName,
            validation: validationClassName,
            validationError: validationErrorClassName
        } })));
}; };
/**
 * Add vanilla props to the return value of calling the given
 * mapStateToProps function.
 *
 * @param mapStateToProps an existing mapStateToProps function for retrieving layout props
 * @returns {VanillaLayoutProps} vanilla specific layout props
 */
exports.addVanillaLayoutProps = function (mapStateToProps) { return function (state, ownProps) {
    var props = mapStateToProps(state, ownProps);
    return tslib_1.__assign(tslib_1.__assign({}, props), { getStyleAsClassName: reducers_1.getStyleAsClassName(state), getStyle: reducers_1.getStyle(state) });
}; };
exports.addVanillaCellProps = function (mapStateToCellsProps) { return function (state, ownProps) {
    var props = mapStateToCellsProps(state, ownProps);
    var inputClassName = ['validate'].concat(props.isValid ? 'valid' : 'invalid');
    return tslib_1.__assign(tslib_1.__assign({}, props), { className: inputClassName.join(' '), getStyleAsClassName: reducers_1.getStyleAsClassName(state), getStyle: reducers_1.getStyle(state) });
}; };
var withVanillaCellPropsForType = function (type) { return function (Component) { return function (props) {
    var inputClassName = ['validate'].concat(props.isValid ? 'valid' : 'invalid');
    var styles = styles_1.useStyles();
    var definedStyle = styling_1.findStyleAsClassName(styles)(type);
    if (definedStyle) {
        inputClassName.push(definedStyle);
    }
    return (react_1.default.createElement(Component, tslib_1.__assign({}, props, { getStyleAsClassName: styling_1.findStyleAsClassName(styles), getStyle: styling_1.findStyle(styles), className: inputClassName.join(' ') })));
}; }; };
exports.withVanillaCellProps = withVanillaCellPropsForType('control.input');
exports.withVanillaEnumCellProps = withVanillaCellPropsForType('control.select');
//# sourceMappingURL=index.js.map